import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatBottomSheet, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { MenuService } from 'src/app/shared/services/menu.service';
declare var dataLayer;
export interface RewardTab {
  label: string;
  content: string;
}
@Component({
  selector: 'app-all-reward-dialog',
  templateUrl: './all-reward-dialog.component.html',
  styleUrls: ['./all-reward-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AllRewardDialogComponent implements OnInit {
  public beveragesCount: number = 10;
   public msrRewardsData: any = [];
  userType: string;
  userId: any;
  tierType: any;
  constructor(private _bottomSheet: MatBottomSheet,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private commonFunction: CommonFunctions,
    private menuService : MenuService
  ) {
    this.msrRewardsData = data;
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
     this.menuService.getExploreMenu().subscribe(res=>{res ? this.closeSheet() : ''})
  }
  closeSheet() {
    this._bottomSheet.dismiss()
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}
